/** Converts a string like `01-01-2025` to a Date with zeroed time components in UTC, so `2020-01-01T00:00:00.000Z`. */
export const jsDateFromYearMonthDayString = (yearMonthDay: string): Date => {
  const [month, day, year] = yearMonthDay
    .split('-')
    .map((it) => parseInt(it, 10))

  return new Date(Date.UTC(year, month - 1, day))
}
